import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);

export function descendingComparator(a, b, orderBy) {
  let valA = a[orderBy];
  let valB = b[orderBy];

  if (orderBy === "publishedOn" || orderBy === "date" || orderBy === "created_at" || orderBy === "publishedon") {
    if (valA && valB) {
      const dateA = dayjs(valA, ["Do MMMM YYYY", "LL", "YYYY-MM-DD", "DD MMM YYYY"]).valueOf();
      const dateB = dayjs(valB, ["Do MMMM YYYY", "LL", "YYYY-MM-DD", "DD MMM YYYY"]).valueOf();
      if (!isNaN(dateA) && !isNaN(dateB)) {
        if (dateB < dateA) return -1;
        if (dateB > dateA) return 1;
        return 0;
      }
    }
  }

  if (typeof valA === 'string' && typeof valB === 'string') {
    valA = valA.toLowerCase();
    valB = valB.toLowerCase();
  }

  if (valB < valA) return -1;
  if (valB > valA) return 1;
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
